import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-432da1ff"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "swiper-container"
};
var _hoisted_2 = {
  ref: "btnPrevRef",
  class: "swiper-button-prev btn-swiper-control"
};
var _hoisted_3 = {
  ref: "btnNextRef",
  class: "swiper-button-next btn-swiper-control"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "swiper-slide-desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SwiperSlide = _resolveComponent("SwiperSlide");
  var _component_Swiper = _resolveComponent("Swiper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, null, 512), _createElementVNode("div", _hoisted_3, null, 512), _ctx.btnPrevRef && _ctx.btnNextRef ? (_openBlock(), _createBlock(_component_Swiper, {
    key: 0,
    modules: _ctx.modules,
    "free-mode": true,
    "slides-per-view": 'auto',
    "space-between": 20,
    navigation: {
      prevEl: _ctx.btnPrevRef,
      nextEl: _ctx.btnNextRef
    }
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item, index) {
        return _openBlock(), _createBlock(_component_SwiperSlide, {
          key: index
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", {
              class: "swiper-slide-item",
              onClick: function ($event) {
                return _ctx.onClickItem(item);
              }
            }, [_createElementVNode("div", {
              class: "hover-image hover-image-absolute",
              style: _normalizeStyle("background-image: url(".concat(item.listBanner, ")"))
            }, null, 4), _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)], 8, _hoisted_4)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }, 8, ["modules", "navigation"])) : _createCommentVNode("", true)]);
}